export default {
  "common":{
    "welcome": "welcome",
    "register": "register",
    "chinese": "chinese",
    "english": "english",
    "khmer": "khmer",
    "captcha": "captcha",
    "sendCaptcha": "send Captcha",
    "china": "china",
    "cambodia": "cambodia",
  }
}